export interface INotification {
    message: string;
    created: string;
    severity: NotificationSeverity;
    type: NotificationType;
    id: string;
    progressInfo?: INotificationProgressInformation;
    sequentialInfo?: INotificationSequentialInformation;
}

export enum NotificationType {
    STATIC,
    PROGRESS,
    SEQUENTIAL,
}

export enum NotificationSeverity {
    INFO,
    SUCCESS,
    ERROR,
    WARNING,
}

export enum ProgressState {
    PENDING,
    SUCCESS,
    FAILURE,
    CANCELLED,
}

export interface INotificationProgressInformation {
    state: ProgressState;
    progressPercentage: number;
    remainingTime: string | null;
}

export interface INotificationSequentialInformation {
    remaining: number;
    total: number;
}
